module.exports = __webpack_public_path__ + "img/balance-minus.072bb651.svg";